export function PageLine({padding="20px",size='1px',type='solid',width="100%"}){

    return(
    <div style={{width,margin:'auto'}}>
        <div style={{padding,width:'100%'}}>
            <div  style={{width:'100%',borderRadius:'10px',borderBottom: size+' '+type+' #aaa',margin:"auto"}}/>
        </div>
    </div>)
}